import { atomWithStorage } from "jotai/utils";

export const articleListAtom = atomWithStorage<string[]>(
  "articleListAtom",
  [],
  undefined,
  { getOnInit: true }
);
